var _path, _path2, _path3, _circle, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M30.5 23.1l5.5 5.5-5.5 5.5M34.4 28.6H23.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M30.5 23.1l5.5 5.5-5.5 5.5M34.4 28.6H23.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M34.2 18.5v-4.8c0-3.1-2.5-5.7-5.7-5.7H7.4c-3.1 0-5.7 2.5-5.7 5.7V29c0 3.1 2.5 5.7 5.7 5.7h14.4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 40.8,
    cy: 28.6,
    r: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M3.1 13.9l14.7 7.8 15.3-8.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.84248509f9f322c33f211bcd83d19282.svg";
export { ForwardRef as ReactComponent };